var exports = {
  "variant": "variant__sDhn8E",
  "emphasized": "emphasized__Cb5KDi",
  "default": "default__gVCVrT",
  "danger": "danger__4_H9jh",
  "success": "success__8TVAFM",
  "warning": "warning__M9Z4Eg",
  "info": "info__s3Uf65",
  "done": "done__xMzOET",
  "hideBackground": "hideBackground__I2Oq2h",
};

__webpack_require__.r(module.exports = exports);
